import MenuComponent from '@/components/MenuComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'

export default {
  data () {
    return {
      loading: false
    }
  },
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated
  },
  methods: {
    getRetraitLabel (retrait) {
      switch (retrait) {
        case 'O': // oui
          return 'oui'
        case 'N': // non
          return 'non'
        default:
          return null
      }
    },
    getCompteReglementLabel (compteReglement) {
      switch (compteReglement) {
        case 'E': // Entreprise
          return 'Entreprise'
        case 'P': // Porteur
          return 'Porteur'
        default:
          return '-'
      }
    },
    getCivility () {
      if (this.$store.state.user.user.civility === 'MONSIEUR') {
        return 'M. '
      }
      if (this.$store.state.user.user.civility === 'MADEMOISELLE') {
        return 'Melle '
      }
      if (this.$store.state.user.user.civility === 'MADAME') {
        return 'Mme '
      }
    },
    getDateValidite (dateValidite) {
      if (dateValidite) {
        var moment = require('moment')
        return moment(dateValidite, 'YYYYMM').format('MM/YYYY')
      }
      return null
    }
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Caractéristiques cartes'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null
  }
}
